import { render, staticRenderFns } from "./talentAll.vue?vue&type=template&id=21871e4a&scoped=true"
import script from "./talentAll.vue?vue&type=script&lang=js"
export * from "./talentAll.vue?vue&type=script&lang=js"
import style0 from "./talentAll.vue?vue&type=style&index=0&id=21871e4a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21871e4a",
  null
  
)

export default component.exports